import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  filterButton: {
    marginLeft: theme.spacing(),
  },
  dialogPaper: {
    minWidth: 400,
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: [theme.spacing(1, 1, 1, 2), "!important"],
  },
  dialogContent: {
    borderTop: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: [theme.spacing(1, 2), "!important"],
  },
  dialogActions: {
    padding: [theme.spacing(2), "!important"],
    justifyContent: ["space-between", "!important"],
  },
  filtersToolbar: {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  filtersTypography: {
    marginRight: [theme.spacing(), "!important"],
  },
  selectedFilterChip: {
    marginRight: theme.spacing(),
  },
}))

export default styles
